import { useLoggerStore } from '@/store/logger/logger-store'

const viewedOnce: string[] = []

export function useDetectShowEvent() {
    const loggerStore = useLoggerStore()

    function trigger(event: { id: string; interface_target: string; interface_path?: string }) {
        if (!viewedOnce.includes(event.id)) {
            loggerStore.logInterfaceEvents({ ...event, eventName: 'interface_show' })
            viewedOnce.push(event.id)
        }
    }

    return {
        trigger,
    }
}
